import { render, staticRenderFns } from "./thirdaccess.vue?vue&type=template&id=6f469558&scoped=true&"
import script from "./thirdaccess.vue?vue&type=script&lang=js&"
export * from "./thirdaccess.vue?vue&type=script&lang=js&"
import style0 from "./thirdaccess.vue?vue&type=style&index=0&id=6f469558&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f469558",
  null
  
)

export default component.exports